module.exports = new __parcel__URL__("uber-grocery.14bb46f7.webp").toString();